import React, { useContext, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { CaretDown as CaretDownIcon } from '@phosphor-icons/react/dist/ssr/CaretDown';
import { CaretRight as CaretRightIcon } from '@phosphor-icons/react/dist/ssr/CaretRight';
import Collapse from '@mui/material/Collapse';
import DataContext from '@/contexts/DataContext';
import { icons } from '@/components/dashboard/layout/nav-icons';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { logger } from '@/lib/default-logger';

const testItems = [1, 2, 3, 4]

export function DetailListExpandable({headerItem = {}, listItems = []}) {
    // // logger.debug('list items', headerItem, listItems);
    const navigate = useNavigate();
    const {currentView, setCurrentView} = useContext(DataContext);
    const [open, setOpen] = useState(false);
    const HeaderIcon = icons[headerItem.icon] || null; 
    const headerPaddingVertical = '3.5%';
    // const headerPaddingBottom = open ? '0%' : headerPaddingVertical;
    // rm extra padding at bottom of header when the card is open
    const headerPaddingBottom = open ? {paddingBottom: '0'} : {}
    const RightArrowIcon = icons['arrow-right'] ||  null; 


    return (
    <Box sx={{ bgcolor: 'none', p: 0,}}>
        <Card>
        <CardHeader 
            avatar={HeaderIcon ? <HeaderIcon /> : null} // throws error if we directly pass icons['iconName']
            title={headerItem?.name || ""} 
            action={
                <IconButton aria-label='collapse/expand button' onClick={() => {setOpen(!open)}} >
                    {open ? <CaretDownIcon /> : <CaretRightIcon />}
                </IconButton>
            }
            sx={headerPaddingBottom}
            // sx={{paddingBottom: headerPaddingBottom, paddingTop: headerPaddingVertical}}
            onClick={() => {setOpen(!open)}}
            />
        <Collapse in={open} timeout="auto" unmountOnExit>
            <CardContent sx={{height: '100%'}}>
                <Stack spacing={2}>
                {/* <List disablePadding sx={{ '& .MuiListItem-root': { px: 0, py: 2 } }}> */}
                <List disablePadding sx={{ '& .MuiListItem-root': { px: 0, py: 1.5} }}>
                    {listItems.map((item, index) => {
                        const ItemIcon = icons[item.icon] ||  null; 
                        // // logger.debug('item icon', item, ItemIcon, item.icon);
                        return (
                            <Link 
                                href={item.href || ""} 
                                underline='none' 
                                color='text.primary'
                                key={index}
                            >
                        <ListItem 
                            // key={item.id} 
                            key={index}
                            // divider={index === listItems.length - 1 ? false : true} onClick={() => {if (item.href) navigate(item.href)}}
                        >
                            {ItemIcon ? 
                                <ListItemIcon>
                                    <ItemIcon />
                                </ListItemIcon> 
                            : <></>}
                            <ListItemText
                                disableTypography
                                primary={
                                <Typography variant="subtitle2"> {/** add noWrap to cut off long text with ... */}
                                    {item.name || ""}
                                </Typography>
                                }
                            />
                            <IconButton 
                            >
                                <ListItemIcon>
                                    <RightArrowIcon />
                                </ListItemIcon>
                            </IconButton>
                        </ListItem>
                         </Link> 
                    )})}                                                          
                </List>
                </Stack>
            </CardContent>
        </Collapse>
        </Card>
    </Box>
    );
}
